var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import { initUlmUrl, refreshSession, ULM_PROFILE_EVENT, updateAuth } from "../../../lib/sso";
import { useHeaderConfig } from "../NavProvider";
import { AuthContext } from "./context";
var AuthProvider = function (props) {
    var shouldOverrideLogout = props.shouldOverrideLogout, children = props.children, hooks = __rest(props, ["shouldOverrideLogout", "children"]);
    var onInit = hooks.onInit, onAuth = hooks.onAuth;
    var _a = useHeaderConfig(), uxfConfig = _a.uxf, ulmConfig = _a.ulm;
    var enableUxf = uxfConfig.whitelistedAddress.includes(window.location.hostname);
    var _b = useState(""), loginUrl = _b[0], setLoginUrl = _b[1];
    var _c = useState(enableUxf || updateAuth()), authenticated = _c[0], setAuthenticated = _c[1];
    useEffect(function () {
        var ulmProfileEventHandler = function () {
            setAuthenticated(enableUxf || updateAuth());
        };
        window.addEventListener(ULM_PROFILE_EVENT, ulmProfileEventHandler);
        return function () {
            window.removeEventListener(ULM_PROFILE_EVENT, ulmProfileEventHandler);
        };
    }, [enableUxf]);
    useEffect(function () {
        var ulmUrl = initUlmUrl(ulmConfig);
        if (ulmUrl) {
            setLoginUrl(ulmUrl);
            onInit && onInit({ ulmUrl: ulmUrl, enableUxf: enableUxf });
            refreshSession(ulmConfig)
                .then(function (ulmProfile) {
                onAuth && onAuth(ulmProfile);
            })
                .catch(function (e) {
                console.error("Failed to refresh session", e === null || e === void 0 ? void 0 : e.message);
            });
        }
    }, [ulmConfig, onInit, onAuth, enableUxf]);
    var context = __assign(__assign({}, hooks), { enableUxf: enableUxf,
        authenticated: authenticated,
        loginUrl: loginUrl,
        shouldOverrideLogout: shouldOverrideLogout });
    return React.createElement(AuthContext.Provider, { value: context }, children);
};
export default AuthProvider;
